import { useState, useContext } from 'react';
import styled, { keyframes } from 'styled-components';
import LogoWhite from '../../assets/scss/black-dashboard-react/panther/logo-white.svg';
import LogoWhiteNoAnim from '../../assets/scss/black-dashboard-react/panther/logo-white-none-anim.svg';
import LogoBlack from '../../assets/scss/black-dashboard-react/panther/logo.svg';
import LogoBlackNoAnim from '../../assets/scss/black-dashboard-react/panther/logoNoAnim.svg';

import AuthContext from '../../context/autenticacion/authContext';
import { useT } from 'i18n';

import DatosPersonales from './DatosPersonales';
import WindowsDatos from '../ActualizarProfileView/WindowsDatos';
import PasswordReset from '../ActualizarProfileView/PasswordReset';
import CentroVerificacion from '../ActualizarProfileView/CentroVerificacion';
import CuentasBancarias from '../ActualizarProfileView/CuentasBancarias';

// Animaciones
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Styled Components
const ProfileContainer = styled.div`
  animation: ${fadeIn} 0.4s ease-out;
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem 2rem;
  background: ${props => props.theme === 'white'
    ? 'linear-gradient(135deg, #f8f9fa, #e9ecef)'
    : 'linear-gradient(135deg, rgba(18,21,28, 0.8), rgba(12,14,19, 0.9))'};
  border-radius: 24px 24px 0 0;
  border-bottom: 1px solid ${props => props.theme === 'white'
    ? 'rgba(0, 0, 0, 0.05)'
    : 'rgba(227,168,43, 0.2)'};

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
    padding: 1.5rem;
  }
`;

const LogoBox = styled.div`
  flex-shrink: 0;
  
  img {
    height: 50px;
    width: auto;
  }
  
  .mobile-responsive-jimf { display: none; }
  
  @media (max-width: 768px) {
    .desktop-responsive-jimf { display: none; }
    .mobile-responsive-jimf { display: block; }
  }
`;

const HeaderInfo = styled.div`
  h2 {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 0.25rem;
    background: ${props => props.theme === 'white'
      ? 'rgba(227,168,43,.14)'
      : 'linear-gradient(135deg, #fff, #e3a82b)'};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    
    strong {
      color: #e3a82b;
      background: none;
      -webkit-background-clip: unset;
      background-clip: unset;
    }
  }
  
  p {
    color: ${props => props.theme === 'white' ? '#666' : 'rgba(255, 255, 255, 0.7)'};
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
  
  span {
    font-size: 0.75rem;
    color: ${props => props.theme === 'white' ? '#999' : 'rgba(255, 255, 255, 0.5)'};
    strong { color: #e3a82b; }
  }
`;

const TabBar = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 1rem 2rem;
  background: ${props => props.theme === 'white'
    ? '#f8f9fa'
    : 'rgba(12,14,19, 0.4)'};
  border-bottom: 1px solid ${props => props.theme === 'white'
    ? 'rgba(0, 0, 0, 0.05)'
    : 'rgba(227,168,43, 0.15)'};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 1rem;
    justify-content: center;
  }
`;

const TabButton = styled.button`
  padding: 0.6rem 1.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  color: ${props => props.theme === 'white' ? '#666' : 'rgba(255, 255, 255, 0.7)'};
  
  ${props => props.active && `
    background: rgba(227,168,43,.14);
    color: #e3a82b;
    box-shadow: inset 0 0 0 1px rgba(227,168,43,.45);
  `}
  
  i { margin-right: 0.5rem; }
  
  &:hover {
    transform: translateY(-2px);
    color: ${props => props.theme === 'white' ? '#e3a82b' : '#fff'};
    background: ${props => props.theme === 'white'
      ? 'rgba(227,168,43, 0.1)'
      : 'rgba(227,168,43, 0.15)'};
  }
`;

const ContentContainer = styled.div`
  padding: 1.5rem;
  min-height: 400px;
  background: ${props => props.theme === 'white'
    ? '#fff'
    : 'rgba(12,14,19, 0.3)'};

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const FooterDecoration = styled.div`
  height: 4px;
  background: linear-gradient(90deg, #e3a82b, #e3a82b, #e3a82b);
  border-radius: 0 0 24px 24px;
`;

const Actualizar = () => {
  const { t } = useT();
  const authContext = useContext(AuthContext);
  const { jimf_theme, usuario, status } = authContext;

  const [layerout, setLayerOut] = useState({
    todos_mis_depositos: true,
    transferencia_nacional: false,
    transferencia_internacional: false,
    centro_verficicacion: false,
  });

  const [completar, setCompletar] = useState(false);
  const isWhiteTheme = jimf_theme === 'white';

  const TodosDepositosLay = () => {
    setLayerOut({
      todos_mis_depositos: true,
      transferencia_nacional: false,
      transferencia_internacional: false,
      centro_verficicacion: false,
    });
  };

  const TransferenciaNacionalLay = () => {
    setLayerOut({
      todos_mis_depositos: false,
      transferencia_nacional: true,
      transferencia_internacional: false,
      centro_verficicacion: false,
    });
  };

  const TransferenciaInterNacionalLay = () => {
    setLayerOut({
      todos_mis_depositos: false,
      transferencia_nacional: false,
      transferencia_internacional: true,
      centro_verficicacion: false,
    });
  };

  const CentroKYC = () => {
    setLayerOut({
      todos_mis_depositos: false,
      transferencia_nacional: false,
      transferencia_internacional: false,
      centro_verficicacion: true,
    });
  };

  const { todos_mis_depositos, transferencia_nacional, transferencia_internacional, centro_verficicacion } = layerout;

  if (completar) {
    return <WindowsDatos setCompletar={setCompletar} />;
  }

  return (
    <ProfileContainer>
      <div className="datos-jimf">
        {/* Header */}
        <HeaderSection theme={isWhiteTheme ? 'white' : 'dark'}>
          <LogoBox>
            {isWhiteTheme ? (
              <>
                <img src={LogoBlackNoAnim} className="mobile-responsive-jimf" alt="Panther7" />
                <img src={LogoBlack} className="desktop-responsive-jimf" alt="Panther7" />
              </>
            ) : (
              <>
                <img src={LogoWhiteNoAnim} className="mobile-responsive-jimf" alt="Panther7" />
                <img src={LogoWhite} className="desktop-responsive-jimf" alt="Panther7" />
              </>
            )}
          </LogoBox>
          <HeaderInfo theme={isWhiteTheme ? 'white' : 'dark'}>
            <h2>
              {t('cuenta.perfilDe')} <strong className="usuario-fill">{usuario?.name || t('cuenta.usuario')}</strong>
            </h2>
            <p>{t('cuenta.plataforma')}</p>
            <span><strong>www.</strong>panther7<strong>.com</strong></span>
          </HeaderInfo>
        </HeaderSection>

        {/* Tabs */}
        <TabBar theme={isWhiteTheme ? 'white' : 'dark'}>
          <TabButton
            theme={isWhiteTheme ? 'white' : 'dark'}
            active={todos_mis_depositos}
            onClick={TodosDepositosLay}
          >
            <i className="tim-icons icon-single-02" /> {t('cuenta.tabDatosPersonales')}
          </TabButton>
          <TabButton
            theme={isWhiteTheme ? 'white' : 'dark'}
            active={transferencia_internacional}
            onClick={TransferenciaInterNacionalLay}
          >
            <i className="tim-icons icon-lock-circle" /> {t('cuenta.tabPrivacidad')}
          </TabButton>
          {status !== 3 && (
            <TabButton
              theme={isWhiteTheme ? 'white' : 'dark'}
              active={centro_verficicacion}
              onClick={CentroKYC}
            >
              <i className="tim-icons icon-shield" /> {t('cuenta.tabVerificacion')}
            </TabButton>
          )}
          <TabButton
            theme={isWhiteTheme ? 'white' : 'dark'}
            active={transferencia_nacional}
            onClick={TransferenciaNacionalLay}
          >
            <i className="tim-icons icon-bank" /> {t('cuenta.tabCuentasBancarias')}
          </TabButton>
        </TabBar>

        {/* Content */}
        <ContentContainer theme={isWhiteTheme ? 'white' : 'dark'}>
          {todos_mis_depositos && (
            <DatosPersonales
              usuario={usuario}
              jimf_theme={jimf_theme}
              setCompletar={setCompletar}
            />
          )}
          {transferencia_internacional && <PasswordReset jimf_theme={jimf_theme} />}
          {transferencia_nacional && <CuentasBancarias jimf_theme={jimf_theme} />}
          {centro_verficicacion && <CentroVerificacion jimf_theme={jimf_theme} />}
        </ContentContainer>

        {/* Footer Decoration */}
        <FooterDecoration />
      </div>
    </ProfileContainer>
  );
};

export default Actualizar;